import Widget from '@/plugins/dashboard/widgets/Welcome/Widget'

export default {
  name: 'Welcome',
  widget: Widget
}
